import * as React from "react";
import { Label } from "../../../components/ui/label";
import { Textarea } from "../../../components/ui/textarea";
import { FieldError } from "./FieldError";
import { Controller } from "react-hook-form";

const TextareaWithRef = React.forwardRef((props, ref) => {
  return <Textarea {...props} ref={ref} />
})

export function TextAreaInput({
  control,          // <-- pass RHF control instead of register
  label,
  id,
  stepName,         // e.g. "step5.description"
  stepId,
  extraInfo,
  disabled,
  textAreaClassname,
}) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>

      <Controller
        name={stepName}
        control={control}
        defaultValue="" // important when using Controller
        render={({ field, fieldState }) => (
          <>
            <TextareaWithRef
              id={id}
              placeholder="Enter text here..."
              disabled={disabled}
              className={textAreaClassname}
              {...field} // gives value, onChange, onBlur, name
            />
            {fieldState.error && <FieldError name={stepName} step={stepId} />}
          </>
        )}
      />

      {extraInfo && <p className="text-xs text-gray-500">{extraInfo}</p>}
    </div>
  );
}
